/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../../../styles/postlogin/booking.css";

// imgaes and icons imports
import HomeIcon from "../../../../assets/services/home.svg"
import EyeOpen from "../../../../assets/booking/eye_open.svg"
import EyeClose from "../../../../assets/booking/eye_close.svg"
import ClockIcon from "../../../../assets/booking/time.svg"
import LocationIcon from "../../../../assets/booking/location.svg"
import NoteIcon from "../../../../assets/booking/note.svg"
import PaymentIcon from "../../../../assets/booking/payment.svg"
import ProfileIcon from "../../../../assets/booking/profile.svg"
import RatingIcon from "../../../../assets/booking/rating_star.svg"
import CallIcon from "../../../../assets/booking/call.svg"

import { getRequest } from "../../../../interceptor/AxiosConfig";
import * as apiEndpoint from "../../../../apis/postlogin/PostloginApis";
// import ErrorMessageHandling from "../../../../utilsfunction/ErrorHandling";
import Error from "../../../../components/Alert/Error";
import ProgressBar from "../../../../components/progressbar/ProgressBar";
import { formateDateTwo } from "../../../../utilsfunction/Functions";

import * as routePath from "../../../../routes"
import { useNavigate } from "react-router-dom";

import CompletedBooking from "./CompletedBooking"
import CancelledBooking from "./CancelledBooking"
import CancelModal from "../../../../components/modals/CancelReasonModal";

import io from 'socket.io-client';
import TrackModal from "../../../../components/modals/TrackModal";
import { useSelector } from "react-redux";
import useCountryState from "../../../../helper/geoLocationHook"

const BookingDetails = () => {
  const navigate = useNavigate()
  const [activeLink, setActiveLink] = useState("current_booking");
  const [loader, setLoader] = useState(false)

  const [errorMessage, setErrorMessage] = useState(null)

  // for showing the track modal
  const [showTrackModal, setShowTrackModal] = useState(false)

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  // const [isExpandedOnViewMore, setIsExpandedOnViewMore] = useState(false);

  const [currentBooking, setCurrentBooking] = useState(null)
  const [currentBookingId, setCurrentBookingId] = useState(null)

  // api call for getting the list of services available

  const getCurrentBooking = async () => {
    setLoader(true)
    await getRequest(`${apiEndpoint.currentBookingEndpoint}`)
      .then((response) => {
        setLoader(false)
        if (response.status === 200) {
          setCurrentBooking(response.data.data)
          setCurrentBookingId(response.data.data.id)
        }
      }).catch((error) => {
        setLoader(false)
        // setErrorMessage(ErrorMessageHandling(error))
        // setErrorMessage("")
      })
  }

  // calling function on component load
  useEffect(() => {
    getCurrentBooking()
  }, [activeLink])

  const [showDetails, setShowDetails] = useState(true);
  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  // cancelling reason
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const [reason, setReason] = useState("");

  const handleSubmit = async (reason) => {
    await getRequest(`${apiEndpoint.cancelBookingAPIEndpoint}/${currentBookingId}?reason=${reason}`)
      .then((res) => {
        if (res.status === 200) {
          navigate(`/${routePath.CustomerLayoutPath}/${routePath.bookingListPath}`)
          setActiveLink("cancelled")
          getBookingHistory("cancelled")
          setReason("")
        }
      })
      .catch((err) => {
        // setErrorMessage(ErrorMessageHandling(err))
        // setErrorMessage("")
      })
  };

  // to get the list of completed and cancelled bookings

  const [bookingHistory, setBookingHistory] = useState(null);

  const getBookingHistory = async (type) => {
    let url;
    if (type === "completed") {
      url = `${apiEndpoint.bookingHistoryAPIEndpoint}?status={completed}`
    } if (type === "cancelled") {
      url = `${apiEndpoint.bookingHistoryAPIEndpoint}?status={cancelled}`
    }

    await getRequest(url)
      .then((res) => {
        setBookingHistory(res.data.data)
      }).catch((err) => {
        // setErrorMessage(ErrorMessageHandling(err))
        // setErrorMessage("")
      })
  }

  // tracking the agent
  const [agentLocation, setAgentLocation] = useState(null);

  useEffect(() => {
    // establish socket connection
    const socket = io('https://api.dospeedo.com');

    // define the event listener for the booking's location updates
    socket.on(`userLocationUpdated_${currentBookingId}`, (updatedLocation) => {
      // console.log('User location updated:', updatedLocation);
      setAgentLocation(updatedLocation);
    });

    // cleanup socket connection when component unmounts
    return () => {
      socket.disconnect();
    };
  }, [currentBookingId]);

  console.log(agentLocation)

  const { markerPosition } = useSelector((state) => state?.geoLocation)
  const { userLocation } = useCountryState(markerPosition?.lat, markerPosition?.lng);

  return (
    <div>
      {loader ? "" :
        <section className="container mx-auto min-h-screen booking mb-10">
          <div className="p-4 ps-0">
            <div className="heading_first">
              My <span className="heading_second">Bookings</span>
            </div>
          </div>
          <div className="flex flex-row justify-evenly booking_topbar mb-4 items-center">
            <div
              className={` cursor-pointer ${activeLink === "current_booking" ? "activeHead" : "head_link"
                }`}
            >
              <span onClick={() => handleLinkClick("current_booking")}>
                {"Ongoing"}
              </span>
            </div>

            <div
              className={` cursor-pointer ${activeLink === "completed" ? "activeHead" : "head_link"
                }`}
            >
              <span onClick={() => { getBookingHistory("completed"); handleLinkClick("completed") }}>
                {"Completed"}
              </span>
            </div>

            <div
              className={` cursor-pointer ${activeLink === "cancelled" ? "activeHead" : "head_link"
                }`}
            >
              <span onClick={() => { getBookingHistory("cancelled"); handleLinkClick("cancelled") }}>
                {"Cancelled"}
              </span>
            </div>

          </div>

          {errorMessage && <Error errorMessage={errorMessage} />}


          {activeLink === "current_booking" && currentBooking &&
            <div className="w-full ongoing_booking flex flex-col items-center">
              <div className="head_details flex justify-between items-center mb-4 w-full">
                <h1 className="heading1 flex items-center gap-2">
                  <><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 9.73405L20.9683 2.27124C20.9661 1.79405 20.5757 1.40884 20.0934 1.40884C19.0336 1.40884 18.4234 1.02364 18.3435 0.860234C18.3425 0.79423 18.3173 0.735798 18.302 0.67304C18.29 0.627594 18.29 0.577819 18.2714 0.534537C18.2462 0.477189 18.2036 0.431743 18.1664 0.380885C18.1379 0.341933 18.1183 0.296484 18.0833 0.261858C18.034 0.214247 17.9717 0.18395 17.9126 0.148242C17.8766 0.126601 17.847 0.0952201 17.8066 0.0789904C17.7027 0.0357083 17.5878 0.0119026 17.4686 0.0119026L3.56746 0.0129846C3.54449 0.0108207 3.52481 0 3.50184 0C3.01844 0 2.62911 0.374401 2.62911 0.85265C2.56677 1.01063 1.95323 1.4099 0.874913 1.4099C0.391513 1.4099 0 1.79727 0 2.27554V9.67575C0 10.154 0.391513 10.5414 0.874913 10.5414C1.95216 10.5414 2.56569 10.9407 2.62474 11.0727C2.62474 11.1376 2.6488 11.1939 2.66192 11.2545C2.67286 11.3053 2.67286 11.3594 2.69255 11.407C2.72098 11.4741 2.7691 11.5271 2.81175 11.5845C2.83581 11.6159 2.85003 11.6548 2.87846 11.683C2.92986 11.7338 2.99548 11.7674 3.05892 11.8041C3.09282 11.8236 3.11906 11.8539 3.15625 11.8691C3.21421 11.894 3.28202 11.8961 3.34654 11.908C3.39685 11.9167 3.44278 11.9383 3.49528 11.9383L17.495 12H17.5005C17.7312 12 17.9511 11.9221 18.1151 11.7609C18.2802 11.5986 18.371 11.3919 18.371 11.1603C18.4344 11.0023 19.048 10.6031 20.1252 10.6031H20.1285C20.1875 10.6031 20.24 10.5803 20.2958 10.5684C20.3527 10.5565 20.4139 10.5555 20.4664 10.5338C20.5102 10.5154 20.5419 10.4819 20.5813 10.457C20.637 10.4224 20.6983 10.3931 20.7442 10.3477C20.7705 10.3217 20.7836 10.2849 20.8066 10.2557C20.8525 10.1973 20.9017 10.141 20.9301 10.0718C20.9498 10.0263 20.9487 9.97332 20.9597 9.92462C20.9739 9.86295 20.9979 9.80343 20.9979 9.73743V9.73526V9.7331L21 9.73405ZM4.35145 3.35544H16.6308C17.1142 3.35544 17.5057 3.74281 17.5057 4.22109C17.5057 4.69936 17.1142 5.08673 16.6308 5.08673H4.35145C3.86805 5.08673 3.47654 4.69936 3.47654 4.22109C3.47654 3.74281 3.86805 3.35544 4.35145 3.35544ZM16.6397 8.54071H4.36041C3.87701 8.54071 3.4855 8.15334 3.4855 7.67507C3.4855 7.19679 3.87701 6.80942 4.36041 6.80942H16.6397C17.1231 6.80942 17.5146 7.19679 17.5146 7.67507C17.5146 8.15334 17.1231 8.54071 16.6397 8.54071Z" fill="white" />
                  </svg>
                  </>{" "}Booking No. #12KL23</h1>
                <span className="otp_section">OTP: {currentBooking?.otp}</span>
              </div>
              <div className="body w-full p-4">

                {/* Details Section */}
                <div className="bg-white mb-2">
                  <div className="flex justify-between detailBox">
                    <div className="flex items-center mb-2 first_section">
                      <img src={HomeIcon} alt="Home Icon" width={"80px"} height={"80px"} />
                      <div className="flex flex-col">
                        <div className="flex items-center"><span className="first_text">{currentBooking?.Service?.name?.split(" - ")[0]} </span><span className="round_dot"></span> <span className="second_text">{currentBooking?.Service?.name?.split(" - ")[1]}</span></div>
                        <div className="sub_text" dangerouslySetInnerHTML={{ __html: currentBooking?.Service?.description }}>

                          {/* {isExpandedOnViewMore ? (
                            <button
                              className="view_button_more_less"
                              onClick={() => setIsExpandedOnViewMore(false)}>
                              View Less
                            </button>
                          ) : (
                            <button
                              className="view_button_more_less"
                              onClick={() => setIsExpandedOnViewMore(true)}>
                              View More
                            </button>
                          )} */}
                        </div>
                        {/* {isExpandedOnViewMore && <p className="sub_text">{""} </p>} */}
                      </div>
                    </div>
                    {/* Toggle Button */}
                    <button
                      onClick={toggleDetails}
                      className="details_button"
                    >
                      {showDetails ? <div className="items-center hide flex gap-2"><img src={EyeClose} alt="" />Hide Details</div> : <div className="items-center view flex gap-2"><img src={EyeOpen} alt="" />View Details</div>}
                    </button>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-4 mb-2 details_section">
                  <div className=" card_section">
                    <div className="flex items-center">
                      <img src={ClockIcon} alt="Calendar Icon" width={"80px"} height={"80px"} />
                      <div>
                        <p className="sub_head">Working Time</p>
                        <p className="sub_text">{formateDateTwo(currentBooking?.date) + " - " + currentBooking?.start_time}</p>
                      </div>
                    </div>
                  </div>

                  <div className="card_section">
                    <div className="flex items-center">
                      <img src={LocationIcon} alt="Location Icon" width={"80px"} height={"80px"} />
                      <div>
                        <p className="sub_head">Location</p>
                        <p className="sub_text">{currentBooking?.address?.location_name}</p>
                      </div>
                    </div>
                  </div>

                  {showDetails &&
                    <><div className="card_section">
                      <div className="flex items-center">
                        <img src={NoteIcon} alt="Note Icon" width={"80px"} height={"80px"} />
                        <div>
                          <p className="sub_head">Note</p>
                          <p className="sub_text">{currentBooking?.note}</p>
                        </div>
                      </div>
                    </div>

                      <div className="card_section">
                        <div className="flex items-center">
                          <img src={PaymentIcon} alt="Money Icon" width={"80px"} height={"80px"} />
                          <div>
                            <p className="sub_head">Cost & Method</p>
                            <p className="sub_text">{currentBooking?.price} - {currentBooking?.payment_method}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>

                {showDetails && <>
                  <div className="py-3 workder_details">
                    <h1 className="py-3 heading">Worker Details</h1>
                    <div className="w-full flex items-center justify-between agent_details p-4 ps-0 flex-wrap gap-5">
                      <div className="flex items-center w-4/12">
                        <img src={ProfileIcon} alt="User Icon" width={"80px"} height={"80px"} />
                        <div className="flex flex-col">
                          <p className="name_head">Name</p>
                          <p className="agent_name">{currentBooking?.job?.employee?.full_name}
                          </p></div>
                      </div>
                      <div className="agent_rating flex gap-2 w-4/12">
                        <img src={RatingIcon} alt="Star Icon" width={"20px"} height={"20px"} />
                        <p className="text">
                          4.5 Rating
                        </p>
                      </div>
                      <div className="flex gap-4 w-4/12">
                        <div onClick={() => setShowTrackModal(!showTrackModal)} className="cursor-pointer flex gap-2 items-center btn_secondary w-6/12 justify-center h-14">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_6980_36201)">
                              <path d="M7.99906 8C8.52648 8 9.04205 7.8436 9.48058 7.55059C9.91911 7.25757 10.2609 6.84109 10.4627 6.35382C10.6646 5.86655 10.7174 5.33038 10.6145 4.81309C10.5116 4.29581 10.2576 3.82066 9.88468 3.44772C9.51174 3.07478 9.03658 2.8208 8.5193 2.71791C8.00202 2.61501 7.46584 2.66782 6.97857 2.86965C6.4913 3.07149 6.07483 3.41328 5.78181 3.85181C5.48879 4.29034 5.33239 4.80592 5.33239 5.33333C5.33239 6.04058 5.61335 6.71885 6.11344 7.21895C6.61354 7.71905 7.29182 8 7.99906 8ZM7.99906 4C8.26277 4 8.52056 4.0782 8.73982 4.22471C8.95909 4.37122 9.12998 4.57945 9.2309 4.82309C9.33182 5.06672 9.35822 5.33481 9.30678 5.59345C9.25533 5.8521 9.12834 6.08967 8.94187 6.27614C8.7554 6.46261 8.51782 6.5896 8.25918 6.64105C8.00054 6.69249 7.73245 6.66609 7.48882 6.56517C7.24518 6.46426 7.03694 6.29336 6.89044 6.07409C6.74393 5.85483 6.66573 5.59704 6.66573 5.33333C6.66573 4.97971 6.8062 4.64057 7.05625 4.39052C7.3063 4.14048 7.64544 4 7.99906 4ZM13.7724 6.10467L13.2931 5.94533C13.3793 5.19862 13.3068 4.4421 13.0801 3.72539C12.8535 3.00868 12.4779 2.34798 11.9781 1.78659C11.4782 1.22521 10.8653 0.77584 10.1795 0.467942C9.49382 0.160045 8.75074 0.000578321 7.99906 0C7.23757 0.00029398 6.48498 0.163796 5.79201 0.47949C5.09903 0.795184 4.48177 1.25574 3.98181 1.83012C3.48185 2.4045 3.1108 3.07936 2.89367 3.80925C2.67653 4.53913 2.61836 5.30707 2.72306 6.06133C2.08508 6.18029 1.49514 6.48128 1.02439 6.928C0.69851 7.23783 0.43944 7.61104 0.263113 8.02469C0.0867854 8.43834 -0.00307348 8.88368 -0.000939424 9.33333V12.05C0.000461639 12.7709 0.234922 13.472 0.667454 14.0487C1.09999 14.6254 1.7074 15.0468 2.39906 15.25L4.31239 15.85C4.63377 15.95 4.96848 16.0006 5.30506 16C5.61039 15.9996 5.91426 15.9579 6.20839 15.876L10.0617 14.736C10.405 14.6423 10.7671 14.6423 11.1104 14.736L12.7017 15.2693C13.0939 15.3648 13.5027 15.37 13.8972 15.2845C14.2917 15.199 14.6616 15.0251 14.9791 14.7758C15.2966 14.5266 15.5534 14.2085 15.73 13.8455C15.9067 13.4826 15.9987 13.0843 15.9991 12.6807V9.248C15.9975 8.55827 15.7828 7.88589 15.3841 7.32303C14.9855 6.76017 14.4225 6.33437 13.7724 6.104V6.10467ZM5.17106 2.508C5.5419 2.13566 5.98261 1.84021 6.46792 1.63862C6.95322 1.43703 7.47355 1.33325 7.99906 1.33325C8.52457 1.33325 9.0449 1.43703 9.53021 1.63862C10.0155 1.84021 10.4562 2.13566 10.8271 2.508C11.5752 3.26076 11.9957 4.27854 11.997 5.33982C11.9984 6.4011 11.5806 7.41997 10.8344 8.17467L8.46573 10.478C8.3421 10.5992 8.17587 10.6671 8.00273 10.6671C7.82959 10.6671 7.66336 10.5992 7.53973 10.478L5.17106 8.18467C4.42137 7.43026 4.0006 6.40989 4.0006 5.34633C4.0006 4.28277 4.42137 3.26241 5.17106 2.508ZM14.6657 12.6807C14.6661 12.8826 14.6205 13.0819 14.5322 13.2635C14.4439 13.4452 14.3154 13.6042 14.1564 13.7287C14.0061 13.8495 13.8311 13.9357 13.6438 13.9812C13.4564 14.0267 13.2613 14.0304 13.0724 13.992L11.5091 13.4667C10.9177 13.2968 10.291 13.2931 9.69773 13.456L5.84173 14.5947C5.47124 14.6969 5.07916 14.6902 4.71239 14.5753L2.78306 13.9753C2.3655 13.8546 1.99837 13.6016 1.73679 13.2545C1.47522 12.9073 1.33332 12.4847 1.33239 12.05V9.33333C1.3309 9.06386 1.38453 8.79692 1.49001 8.54894C1.59548 8.30095 1.75057 8.07717 1.94573 7.89133C2.25123 7.60018 2.64041 7.41223 3.05839 7.354C3.32713 8.02012 3.72731 8.62527 4.23506 9.13333L6.61306 11.4353C6.98473 11.7993 7.48421 12.0031 8.00439 12.0031C8.52458 12.0031 9.02405 11.7993 9.39573 11.4353L11.7711 9.12667C12.3029 8.59269 12.7149 7.95159 12.9797 7.246L13.3377 7.36467C13.726 7.50379 14.0618 7.7593 14.2995 8.09636C14.5372 8.43341 14.6651 8.83558 14.6657 9.248V12.6807Z" fill="#1B9075" />
                            </g>
                            <defs>
                              <clipPath id="clip0_6980_36201">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <div>Track Location</div>
                        </div>
                        <button className="btn_primary w-6/12 h-6">
                          <a href={`tel:${currentBooking?.job?.employee?.phone_number}`} className="agentcall_btn  flex gap-4 items-center justify-center h-6"><img src={CallIcon} alt="" width={"20px"} height={"20px"} />Call</a>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
                }
              </div>
              <div className="w-full p-4 mb-6 agent_status">
                <div className="mx-auto w-10/12">
                  <ProgressBar step1={true} step2={false} step3={false} />
                </div>
                <div className="px-8 text agent_status_text">
                  {currentBooking?.job?.employee?.full_name} is on the way
                </div>
              </div>
              <div className="flex justify-end my-4 w-full">
                <button className="w-2/12 cancel_button" onClick={() => handleOpenModal()}>Cancel Your Booking</button>
              </div>
            </div>
          }
          {!currentBooking && <div className="first_head">No Booking Found</div>}
          <CancelModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onSubmit={handleSubmit}
            reason={reason}
            setReason={setReason}
          />

          <TrackModal
            show={showTrackModal}
            setShow={setShowTrackModal}
            userLocation={userLocation}
            maidLocation={agentLocation}
          />

          {activeLink === "completed" &&
            <div className="flex gap-2">
              <CompletedBooking bookingDetails={bookingHistory} />
            </div>}

          {activeLink === "cancelled" && <CancelledBooking bookingDetails={bookingHistory} />}
        </section>}
    </div>
  );
};

export default BookingDetails;
